var exports = {
  "k": "InviteDateToggle.module__container___d3hUQ0",
  "P": "InviteDateToggle.module__label___d3hUQ0",
};

module.exports = exports;
